import React, { useState } from "react";
import {Col, Row, FormGroup, Container, Modal} from "react-bootstrap";
import { Form, Input, Radio, Checkbox, DatePicker, Select } from 'antd';
import { Breadcrumb, ImageElement, LoginHeader} from "../../components";
import { Link } from "react-router-dom";

function Payment() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Payment',
        },
    ];
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content paymentPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <Breadcrumb title="Payment" breadcrumb={breadcrumb}/>
                            {/* Payment page content */}
                            <div className="br-10 p-30 bg-white">
                                <h2 className="text-850 font-sm paymentPage_head_title paymentPage_head_title-selectTitle">How would you like to pay ?</h2>
                                <Row className="g-3">
                                    <Col sm={6}>
                                        <Link to="/payment" className="paymentPage_item d-flex justify-content-center align-items-center flex-column">
                                            <div className="icons d-flex justify-content-center align-items-center">
                                                <em className="gg-credit-card" />
                                            </div>
                                            <p className="font-md">Credit Card</p>
                                        </Link>
                                    </Col>
                                    <Col sm={6}>
                                        <Link onClick={handleShow} className="paymentPage_item d-flex justify-content-center align-items-center flex-column">
                                            <div className="icons d-flex justify-content-center align-items-center">
                                                <em className="gg-cash-payment" />
                                            </div>
                                            <p className="font-md">Cash Payment</p>
                                        </Link>
                                    </Col>
                                    <Col sm={6}>
                                        <Link onClick={handleShow} className="paymentPage_item d-flex justify-content-center align-items-center flex-column">
                                            <div className="icons d-flex justify-content-center align-items-center">
                                                <em className="gg-cheque" />
                                            </div>
                                            <p className="font-md">Cheque</p>
                                        </Link>
                                    </Col>
                                    <Col sm={6}>
                                        <Link onClick={handleShow} className="paymentPage_item d-flex justify-content-center align-items-center flex-column">
                                            <div className="icons d-flex justify-content-center align-items-center">
                                                <em className="gg-financing" />
                                            </div>
                                            <p className="font-md">Financing</p>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered id="addLocation" className="addLocation" backdrop="static">
                <Modal.Header closeButton className="align-items-start justify-content-center">
                    <div className="text-center">
                        <Modal.Title>Please Install the application in order to Pay VIA Cash, Check or Financing</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to="/" className="me-3"> <ImageElement className="img-fluid" source="google-play.svg" alt="Google-play"/></Link>
                        <Link to="/"> <ImageElement className="img-fluid" source="app-store.svg" alt="App-store" /> </Link>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Payment;